<div [ngStyle]="{ height: '100%' }" fxLayout="column">
  <div fxFlex="100%" class="u-overflow-auto u-showScrollBar u-padding-24">
    <app-group-match-exclusions-form
      class="u-display-block"
      [group]="group"
      [account]="account"
      [programMembership]="programMembership"
      (selectionChange)="selectionChange($event)"
    ></app-group-match-exclusions-form>
  </div>
  <div
    class="u-padding-8-0 u-padding-0-16 u-borderTop-grey100"
    fxFlex="0 0 auto"
    fxLayoutAlign="end center"
    fxLayoutGap="8px"
  >
    <button
      mat-button
      type="button"
      (click)="drawerRef.close()"
      i18n="@@global.cancel"
    >
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="
        programMembership
          ? saveMatchExclusionsForProgramMembership(
              group,
              program,
              programMembership,
              selections
            )
          : save(group, account, selections)
      "
      [disabled]="isLoading"
    >
      <span i18n="@@global.save">Save</span>
      <i
        *ngIf="isLoading"
        nz-icon
        nzType="sync"
        nzTheme="outline"
        nzSpin
        class="u-marginLeft-8"
      ></i>
    </button>
  </div>
</div>
